import React from 'react';
import { formatDate } from './formatDate';

/**
 * Service date display
 */
export const ServiceDateTemplate: React.FC<{ serviceDate?: string }> = ({ serviceDate }) => (
  <span>{formatDate(serviceDate)}</span>
);

export default ServiceDateTemplate;
